// JavaScript source code
import { GetGame, IsValid, IsMobile } from "./Utilities.js";
import "./styles/GameImageHeader.css";
import { useState, useRef, useEffect } from 'react';

function GameImageHeader({ gameHeaderDic, newCurrIndex }) {
    const [currIndex, setCurrIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(0);
    const [refresh, setRefresh] = useState(false);
    const [mobile, setMobile] = useState(IsMobile());
    const gameInfoList = useRef({});
    const [gameInfoState, setGameInfoState] = useState(gameHeaderDic || {});
    const newBackgroundImage = useRef();
    const animationState = useRef();

    useEffect(() => {
        if (refresh === true) setRefresh(false);
    }, [refresh]);

    useEffect(() => {
        const handleResize = () => {
            setMobile(IsMobile());
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    /*useEffect(() => {
        const signUpReqOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        fetch(/*process.env.REACT_APP_NODE_ADDRESS "https://www.devpowered.com:8100/GetHomePageHeaderGames", signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    var gamesArray = JSON.parse(data.message);
                    setCurrIndex(gamesArray[0]);
                    
                    gamesArray.map((ID) => {
                        GetGame(ID).then((gameInfo) => {

                            console.log(gameInfo);

                            if (gameInfo.success === true) {
                                gameInfoList.current[ID] = gameInfo.message;
                            }

                            console.log(Object.entries(gameInfoList.current).length);

                            if (Object.entries(gameInfoList.current).length === 5) {
                                setTimeout(10);
                                setGameInfoState(gameInfoList.current);
                            }
                        });
                        return;
                    });
                }
            });
    }, []);*/

    useEffect(() => {
        newCurrIndex(currIndex);
    }, [currIndex]);

    useEffect(() => {
        if (IsValid(gameHeaderDic) === true && Object.entries(gameHeaderDic).length > 0) {
            setCurrIndex(Object.entries(gameHeaderDic)[0][0]);
            setGameInfoState(gameHeaderDic);
        }
    }, [gameHeaderDic])

    function onValueChange(event) {
        /*console.log(event.target.id);
        if (animationState.current === "fadeOut") {
            setNextIndex(parseInt(event.target.id));
            return;
        }
        animationState.current = "fadeOut";

        setNextIndex(parseInt(event.target.id))*/
        setCurrIndex(event.target.id);
    }

    function onFadeAnimationChange() {
        //console.log("Anim ended");
        if (animationState.current === "fadeIn") {
            animationState.current = "fadeOut";
        }
        else if (animationState.current === "fadeOut") {
            animationState.current = "fadeIn";
            setCurrIndex(nextIndex);
            setRefresh(true);
        }
    }

    return (
        <div className={/*mobile ? "mobileTitleLineContainer" :*/ "titleLineContainer"}>
            {IsValid(gameInfoState[currIndex]) === true && <div className={/*mobile ? "mobileTitleLineBackground" :*/ "titleLineBackground"} style={{
                'background-image': `url("` + process.env.REACT_APP_S3_BASE_URL + gameInfoState[currIndex].PhotoUrl + `")`,
            }} />}
            <div className="gameImageSelectors">
                <form className="imageSelectorsForm" >
                    {refresh === false && Object.entries(gameInfoState).length > 0 && Object.entries(gameInfoState).map((game, index) => {
                        return (<img className={game[0] == currIndex ? "headerImageSelected" : "headerImage"} onClick={onValueChange} src={process.env.REACT_APP_S3_BASE_URL + gameInfoState[game[0]].PhotoUrl} id={game[0]} name="image" value={game[0].ID} />);
                    })}
                </form>
            </div>
        </div>
    );
}

export default GameImageHeader;